module.exports = __webpack_public_path__ + "static/media/about_bg1_sp.05d6f8f1.jpg";